import React, { useState, useEffect } from "react";
// import cloneDeep from "lodash.clonedeep";
import { useEvent, getColors } from "../../utils/gameutil";
import Swipe from "react-easy-swipe";
import { cloneDeep } from "lodash";
import "./css/game.css";


export const Game=()=> {
  const UP_ARROW = 38;
  const DOWN_ARROW = 40;
  const LEFT_ARROW = 37;
  const RIGHT_ARROW = 39;
  const [data, setData] = useState([
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
  ]);

  const [gameOver, setGameOver] = useState(false);
  //const [won, setWon] = useState(false);
  // Initialize
  const initialize = () => {
    
    let newGrid = cloneDeep(data);

    addNumber(newGrid);
    addNumber(newGrid);
    setData(newGrid);
  };

  // AddNumber - Add an item
  const addNumber = (newGrid) => {
    let added = false;
    let gridFull = false;
    let attempts = 0;
    // Loop runs till new number is added
    while (!added) {
      if (gridFull) {
        break;
      }
      // find index value from 0-3 
      let i = Math.floor(Math.random() * 4);
      let j = Math.floor(Math.random() * 4);
      attempts++;
      if (newGrid[i][j] === 0) {
        newGrid[i][j] = 2;
        added = true;
      }
      if (attempts > 50) {
        gridFull = true;
        let gameOverr = checkIfGameOver();
        if (gameOverr) {
          // alert("game over");
          setGameOver(true);
        }
        setGameOver(true);
      }
    }
  };

 // Swipe Left
 const swipeLeft = (dummy) => {
  // console.log("swipe left");
  let oldGrid = data;
  let newArray = cloneDeep(data);

  for (let i = 0; i < 4; i++) {
    let b = newArray[i];
    let slow = 0;
    let fast = 1;
    while (slow < 4) {
      if (fast === 4) {
        fast = slow + 1;
        slow++;
        continue;
      }
      if (b[slow] === 0 && b[fast] === 0) {
        fast++;
      } else if (b[slow] === 0 && b[fast] !== 0) {
        b[slow] = b[fast];
        b[fast] = 0;
        fast++;
      } else if (b[slow] !== 0 && b[fast] === 0) {
        fast++;
      } else if (b[slow] !== 0 && b[fast] !== 0) {
        if (b[slow] === b[fast]) {
          b[slow] = b[slow] + b[fast];
          b[fast] = 0;
          fast = slow + 1;
          slow++;
        } else {
          slow++;
          fast = slow + 1;
        }
      }
    }
  }
  if (JSON.stringify(oldGrid) !== JSON.stringify(newArray)) {
    addNumber(newArray);
  }
  if (dummy) {
    return newArray;
  } else {
    setData(newArray);
  }
};

const swipeRight = (dummy) => {
  // console.log("swipe right");
  let oldData = data;
  let newArray = cloneDeep(data);

  for (let i = 3; i >= 0; i--) {
    let b = newArray[i];
    let slow = b.length - 1;
    let fast = slow - 1;
    while (slow > 0) {
      if (fast === -1) {
        fast = slow - 1;
        slow--;
        continue;
      }
      if (b[slow] === 0 && b[fast] === 0) {
        fast--;
      } else if (b[slow] === 0 && b[fast] !== 0) {
        b[slow] = b[fast];
        b[fast] = 0;
        fast--;
      } else if (b[slow] !== 0 && b[fast] === 0) {
        fast--;
      } else if (b[slow] !== 0 && b[fast] !== 0) {
        if (b[slow] === b[fast]) {
          b[slow] = b[slow] + b[fast];
          b[fast] = 0;
          fast = slow - 1;
          slow--;
        } else {
          slow--;
          fast = slow - 1;
        }
      }
    }
  }
  if (JSON.stringify(newArray) !== JSON.stringify(oldData)) {
    addNumber(newArray);
  }
  if (dummy) {
    return newArray;
  } else {
    setData(newArray);
  }
};

const swipeDown = (dummy) => {
  // console.log("swipe down");
  // console.log(data);
  let b = cloneDeep(data);
  let oldData = JSON.parse(JSON.stringify(data));
  for (let i = 3; i >= 0; i--) {
    let slow = b.length - 1;
    let fast = slow - 1;
    while (slow > 0) {
      if (fast === -1) {
        fast = slow - 1;
        slow--;
        continue;
      }
      if (b[slow][i] === 0 && b[fast][i] === 0) {
        fast--;
      } else if (b[slow][i] === 0 && b[fast][i] !== 0) {
        b[slow][i] = b[fast][i];
        b[fast][i] = 0;
        fast--;
      } else if (b[slow][i] !== 0 && b[fast][i] === 0) {
        fast--;
      } else if (b[slow][i] !== 0 && b[fast][i] !== 0) {
        if (b[slow][i] === b[fast][i]) {
          b[slow][i] = b[slow][i] + b[fast][i];
          b[fast][i] = 0;
          fast = slow - 1;
          slow--;
        } else {
          slow--;
          fast = slow - 1;
        }
      }
    }
  }
  if (JSON.stringify(b) !== JSON.stringify(oldData)) {
    addNumber(b);
  }
  if (dummy) {
    return b;
  } else {
    setData(b);
  }
};

const swipeUp = (dummy) => {
  // console.log("swipe up");
  let b = cloneDeep(data);
  let oldData = JSON.parse(JSON.stringify(data));
  for (let i = 0; i < 4; i++) {
    let slow = 0;
    let fast = 1;
    while (slow < 4) {
      if (fast === 4) {
        fast = slow + 1;
        slow++;
        continue;
      }
      if (b[slow][i] === 0 && b[fast][i] === 0) {
        fast++;
      } else if (b[slow][i] === 0 && b[fast][i] !== 0) {
        b[slow][i] = b[fast][i];
        b[fast][i] = 0;
        fast++;
      } else if (b[slow][i] !== 0 && b[fast][i] === 0) {
        fast++;
      } else if (b[slow][i] !== 0 && b[fast][i] !== 0) {
        if (b[slow][i] === b[fast][i]) {
          b[slow][i] = b[slow][i] + b[fast][i];
          b[fast][i] = 0;
          fast = slow + 1;
          slow++;
        } else {
          slow++;
          fast = slow + 1;
        }
      }
    }
  }
  if (JSON.stringify(oldData) !== JSON.stringify(b)) {
    addNumber(b);
  }
  if (dummy) {
    return b;
  } else {
    setData(b);
  }
};

// Check Gameover
const checkIfGameOver = () => {
  // console.log("CHECKING GAME OVER");
  // let original = cloneDeep(data);
  let checker = swipeLeft(true);

  if (JSON.stringify(data) !== JSON.stringify(checker)) {
    
    return false;
  }

  let checker2 = swipeDown(true);
  // console.log("CHECKER DOWN");
  // console.table(data);
  // console.table(checker2);
  if (JSON.stringify(data) !== JSON.stringify(checker2)) {
    return false;
  }

  let checker3 = swipeRight(true);

  if (JSON.stringify(data) !== JSON.stringify(checker3)) {
    return false;
  }

  let checker4 = swipeUp(true);

  if (JSON.stringify(data) !== JSON.stringify(checker4)) {
    return false;
  }
  console.log(gameOver)
  return true;

    
  };
  // Reset Game function
const resetGame = () => {
    setGameOver(false);
    const emptyGrid = [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ];

    addNumber(emptyGrid);
    addNumber(emptyGrid);
    setData(emptyGrid);
  };

  
  const handleKeyDown = (event) => {
    let gameOver=checkIfGameOver();
    if (gameOver) {
      return;
    }
    switch (event.keyCode) {
      case UP_ARROW:
        swipeUp();
        break;

      case DOWN_ARROW:
        swipeDown();
        break;

      case LEFT_ARROW:
        swipeLeft();
        break;

      case RIGHT_ARROW:
        swipeRight();
        break;

      default:
        break;
    }

    let gameOverr = checkIfGameOver();
    if (gameOverr) {
      setGameOver(true);
    }
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line
  }, []);

  // This is a custom function
  useEvent("keydown", handleKeyDown);

  return (
    <div >
       
      <div className="game-body">
        <div className="game-title" >
          <div className="game-title-sub game-title-1">
            2048
          </div>
          <div className="game-title-sub game-title-2">
            <div onClick={resetGame} className="game-reset-button">
              NEW GAME
            </div>
          </div>
        </div>
        <div className="game-grid">
          {gameOver && (
            <div className="game-over-overlay" >
              <div>
                <div className="game-over-content">
                  Game Over
                </div>
                <div>
                  <div className="game-over-subcontent">
                    <div onClick={resetGame} className="game-try-again-button">
                      Try Again
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <Swipe
            onSwipeDown={() => swipeDown()}
            onSwipeLeft={() => swipeLeft()}
            onSwipeRight={() => swipeRight()}
            onSwipeUp={() => swipeUp()}
            style={{ overflowY: "hidden" }}
          >
            {data.map((row, oneIndex) => {
              return (
                <div style={{ display: "flex" }} key={oneIndex}>
                  {row.map((digit, index) => (
                    <Block num={digit} key={index} />
                  ))}
                </div>
              );
            })}
          </Swipe>
        </div>

        <div className="game-footer">
          
          <p className="game-explanation">
            <strong className="important">How to play:</strong> Use your{" "}
            <strong className="important">arrow keys</strong> to move the tiles. When two tiles with
            the same number touch, they <strong className="important">merge into one!</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

const Block = ({ num }) => {
  return (
    <div className="game-blockstyle"
      style={{
        
        background: getColors(num),
        color: num === 2 || num === 4 ? "#645B52" : "#F7F4EF",
      }}
    >
      {num !== 0 ? num : ""}
    </div>
  );
};


